import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Photo} from "../../models/data.model";
import {PhotosViewerPage} from "../photos-viewer/photos-viewer";


/**
 * Generated class for the ContactPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html',
})
export class ContactPage {

  constructor(public data: DataProvider, public navCtrl: NavController) {
  }

  protected getContactContent(): string {
    return (this.data.getContactContent() !== null) ? this.data.getContactContent().text : "";
  }

  protected clickText(event: Event) {
    const element: HTMLElement = <HTMLElement>event.target;
    if (element.nodeName != "IMG") return;
    const photo: Photo = {
      name: "photo",
      url: (<HTMLImageElement>element).src
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts